// Import DC and dependencies

d3 = require("d3");
crossfilter = require("crossfilter");
module.exports = require("./dc");



//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/dc/index.js
// module id = 113
// module chunks = 0